import AppConstants from 'constants/AppConstants';

interface State {
  title: string;
  subtitle?: string;
}

const initialState: State = {
  title: '',
};

export default function reducer(state: State = initialState, action: BaseTockAction): State {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.CHECKOUT_SET_STATUS: {
      return {
        ...payload,
      };
    }
    default:
      return state;
  }
}
